import React, { Fragment } from 'react';
import CodeGIF from '../../assets/images/DIAMONDS_EDIT_3_NESTED.gif'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import _ from 'underscore';
import { Container, Row, Col } from 'react-bootstrap';
import queryString from 'query-string';
import { getProductsAction } from '../../store';
import Products from '../common/ProductCard/Products';
import MessageModal from '../common/MessageModal';
import Menus from '../common/SingleMenu/menus';
import {
  setProductConfigurationAction,
  getProductAction,
  getProductPartsAction,
  getThemesAction,
  setQueryStringAction,
} from '../../store/actions';
import Logo from './logo.svg';
import LHLogo from './lh-logo.svg';
import APlogo from './ap-logo.svg';
import HarLogo from './harrods.png';
import DesignYard from './designyard.png';
import Rocks from './rocks.png';
import RVLogo from './rivolilogo.svg'
import HadMond from './Hadmond.png';

class Archive extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      productsGroup: [],
      modalVisible: false,
      toProduct: false,
      selectedProduct: {},
    };

    props.dispatchSetConfiguration({
      ...props.configuration,
      message: ""
    })
  }

  componentDidMount() {
    const {
      dispatchGetProducts, showLoading, match, location: { search }, dispatchSetQueryString,
    } = this.props;
    const query = queryString.parse(search);

    if (query && !_.isEmpty(query)) {
      const retailer = {
        retailer: {
          id: query.retailer,
          name: query.retailer_name,
        },
        seller: {
          id: query.seller,
          name: query.seller_name,
        },
      };

      dispatchSetQueryString(retailer);
    }
    showLoading(true);

    dispatchGetProducts().then(() => {
      const { products } = this.props;
      let productID = {};
      if (match.params.id) {
        productID = _.filter(
          products.data,
          product => product.id === parseInt(match.params.id, 10),
        );
        [productID] = productID;
      }
      if (_.isEmpty(productID)) {
        productID = {};
      }
      const tempProducts = products.data.map(value => ({ product: value, value: value.slug }));
      const filterProducts = tempProducts.filter((product) => product.product.id !== 6336 && product.product.id !== 2096);
      console.log('products', filterProducts);
      // console.log('filter result', filterProducts);
      this.setState(
        {
          productsGroup: filterProducts,
          modalVisible: !!match.params.id && !_.isEmpty(productID),
          selectedProduct: match.params.id
            ? productID
            : {},
        },
        () => showLoading(false),
      );
    });
  }

  render() {
    const {
      modalVisible, selectedProduct, productsGroup, toProduct,
    } = this.state;
    if (toProduct) {
      return <Redirect to="/product" />;
    }
    return (
      <Fragment>
        <MessageModal
          {...this.props}
          isOpen={modalVisible}
          onClose={() => this.setState({ modalVisible: false })}
          product={selectedProduct}
        />
        <Container className="relative archive flex flex-col items-center">
          {/* <button
            className='bg-[#183e3f] absolute max-sm:hidden left-0 top-4 text-white text-lg font-bold rounded-[0.2rem] px-4 py-3 flex items-center justify-center'
            style={{ fontFamily: "Cormorant Garamond", fontStyle: "italic" }}
            onClick={() => window.location.href = "https://www.codebyedge.com/"}
          >
            Tap for Homepage
          </button> */}
          <div className='flex w-full lg:justify-center gap-4 flex-col items-center mb-5'>
            {window.location.href.includes('harrods') && (
              <img src={HarLogo} className="ml-3" alt="hr-logo" srcSet='' width={300} />
            )}
            {window.location.href.includes('rivoli') && (
              <img src={RVLogo} className="ml-3" alt="rv-logo" srcSet='' width={300} />
            )}
            {window.location.href.includes('designyard') && (
              <img src={DesignYard} className="ml-2 w-[250px]" alt="hr-logo" srcSet='' />
            )}
            {window.location.href.includes('rocks') && (
              <img src={Rocks} className="ml-2 w-[250px]" alt="rocks-logo" srcSet='' />
            )}
            {window.location.href.includes('lister') && (
              <img src={LHLogo} className="ml-2" alt="lh-logo" srcSet='' width={400} />
            )}
            {window.location.href.includes('anjapotze') && (
              <img src={APlogo} className="ml-3" alt="lh-logo" srcSet='' width={400} />
            )}
            {window.location.href.includes('hadmond') && (
              <img src={HadMond} className="ml-3" alt="lh-logo" srcSet='' width={400} />
            )}

            <img src={Logo} width={200} className='cursor-pointer' onClick={() => window.location.href = "https://www.codebyedge.com/"}/>
            <button
              className='bg-[#183e3f]  left-0 top-4 text-white  text-lg font-bold rounded-[0.2rem] px-4 py-3 items-center justify-center'
              style={{ fontFamily: "Cormorant Garamond", fontStyle: "italic" }}
              onClick={() => window.location.href = "https://www.codebyedge.com/"}
            >
              Tap for Homepage
            </button>
          </div>
          <div className='mb-4'>
            <Col className="self-center">
              <img src={CodeGIF} alt="code-gif" />
            </Col>
          </div>
          <Row>
            <Col className="text-[30px] text-[#183e3f] text-center mb-2">
              <h1 style={{ fontFamily: 'Cormorant serif' }}>
                codebyEdge is not just jewellery, it’s a love story told in gems
              </h1>
            </Col>
          </Row>
          <Row className='max-sm:hidden'>
            <Col className="text-[23px] text-[#183e3f] text-center mb-[60px]">
              <h1 style={{ fontFamily: 'Cormorant serif' }}>
                Personalise your Morse code love story below
              </h1>
            </Col>
          </Row>
          <Row className='max-sm:flex hidden text-center'>
            <Col className="text-[23px] text-[#183e3f] text-center mb-[60px]">
              <h1 style={{ fontFamily: 'Cormorant serif' }}>
                Personalise your Morse code
                <br />
                love story
                <br />
                below
              </h1>
            </Col>
          </Row>
          <Row className='px-2 lg:px-0'>
            {_.size(productsGroup) > 0 && (
              <Products
                options={productsGroup}
                onOptionPress={values => this.setState({ productsGroup: values })}
                onDoubleClick={(product) => {
                  const { configuration } = this.props;
                  if (configuration.message !== '') {
                    let { message } = configuration;
                    if (product.id === 408 && configuration.message.length === 1) {
                      message = configuration.message + configuration.message;
                    }
                    const {
                      dispatchSetConfiguration,
                      dispatchGetProduct,
                      dispatchGetProductParts,
                      dispatchGetThemes,
                    } = this.props;
                    Promise.all([
                      dispatchGetProduct(product.id, { message }),
                      dispatchGetProductParts(product.id),
                      dispatchGetThemes(),
                    ]).then((result) => {
                      const { payload: { data } } = result[0];
                      if (data.error) {
                        dispatchSetConfiguration({
                          ...configuration,
                          message: '',
                        });
                        this.setState({ modalVisible: true, selectedProduct: product });
                      } else {
                        const paMaterial = _.find(data.attributes, item => item.slug === 'pa_material');
                        const paStoneType = _.find(data.attributes, item => item.slug === 'pa_stone-type');
                        const paSize = _.find(data.attributes, item => item.slug === 'pa_size');
                        const paHookTypeEarrings = _.find(data.attributes, item => item.slug === 'pa_hook-type-earrings');
                        const paStone = _.find(Menus.getColorsSubMenu(), item => item.selected);
                        const newStone = { ...paStone, choice: Menus.lettersChoices(message, _.find(result[2].payload.data, theme => 'code-standard' === theme.slug).stones, true), selected_theme: 'code-standard' };
                        dispatchSetConfiguration({
                          ...configuration,
                          message,
                          pa_material:
                            !_.isEmpty(paMaterial)
                              ? _.find(paMaterial.options, item => item.selected) : false,
                          pa_stone_type:
                            !_.isEmpty(paStoneType)
                              ? _.find(paStoneType.options, item => item.selected) : false,
                          pa_size:
                            !_.isEmpty(paSize)
                              ? _.find(paSize.options, item => item.selected) : false,
                          pa_hook_type_earrings:
                            !_.isEmpty(paHookTypeEarrings)
                              ? _.find(paHookTypeEarrings.options, item => item.selected) : false,
                          pa_stone: newStone,
                        });
                        this.setState({ toProduct: true });
                      }
                    });
                  } else {
                    this.setState({ modalVisible: true, selectedProduct: product });
                  }
                }
                }
              />
            )}
          </Row>
        </Container>
      </Fragment>
    );
  }
}

Archive.propTypes = {
  dispatchGetProducts: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  dispatchSetConfiguration: PropTypes.func.isRequired,
  dispatchGetProduct: PropTypes.func.isRequired,
  products: PropTypes.instanceOf(Object).isRequired,
  configuration: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  dispatchGetProductParts: PropTypes.func.isRequired,
  dispatchGetThemes: PropTypes.func.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  dispatchSetQueryString: PropTypes.func.isRequired,
  preMadeProduct: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = state => ({
  products: state.products,
  configuration: state.configuration,
  preMadeProduct: state.preMadeProduct,
});

const mapDispatchToProps = {
  dispatchGetProducts: getProductsAction,
  dispatchSetConfiguration: setProductConfigurationAction,
  dispatchGetProduct: getProductAction,
  dispatchGetProductParts: getProductPartsAction,
  dispatchGetThemes: getThemesAction,
  dispatchSetQueryString: setQueryStringAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Archive);
